import { resolveRepositoryType, STORAGE_REPOSITORY_TYPE } from "data-tiering/repository-management/types";
import azureDefinition from "./azure";
import gcsDefinition from "./gcs";
import s3Definition from "./s3";
const DEFINITIONS = {
  [STORAGE_REPOSITORY_TYPE.S3]: s3Definition,
  [STORAGE_REPOSITORY_TYPE.GCS]: gcsDefinition,
  [STORAGE_REPOSITORY_TYPE.ABS]: azureDefinition
};
export const getCredentialsDefinition = (type) => DEFINITIONS[resolveRepositoryType(type)];
export const hasCredentialsDefinition = (type) => !!getCredentialsDefinition(type);
